/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CharterBlock } from './';
import {
    CharterBlockFromJSON,
    CharterBlockFromJSONTyped,
    CharterBlockToJSON,
} from './';

/**
 * 
 * @export
 * @interface CharterBlockResource
 */
export interface CharterBlockResource {
    /**
     * 
     * @type {CharterBlock}
     * @memberof CharterBlockResource
     */
    type: CharterBlock;
    /**
     * 
     * @type {string}
     * @memberof CharterBlockResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CharterBlockResource
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof CharterBlockResource
     */
    icon: string;
}

/**
 * Check if a given object implements the CharterBlockResource interface.
 */
export function instanceOfCharterBlockResource(value: object): value is CharterBlockResource {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function CharterBlockResourceFromJSON(json: any): CharterBlockResource {
    return CharterBlockResourceFromJSONTyped(json, false);
}

export function CharterBlockResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharterBlockResource {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CharterBlockFromJSON(json['type']),
        'title': json['title'],
        'body': json['body'],
        'icon': json['icon'],
    };
}

export function CharterBlockResourceToJSON(value?: CharterBlockResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': CharterBlockToJSON(value['type']),
        'title': value['title'],
        'body': value['body'],
        'icon': value['icon'],
    };
}

